export function setToken(token) {
  localStorage.setItem('admin_token', token)
}
export function getToken() {
  return localStorage.getItem('admin_token') || ''
}
export function removeToken() {
  localStorage.removeItem('admin_token')
}

export function setAdminInfo(data) {
  localStorage.setItem('admin_info', JSON.stringify(data))
}
export function getAdminInfo() {
  const str = localStorage.getItem('admin_info')
  return str ? JSON.parse(str) : null
}
export function clearStorage() {
  removeToken()
  localStorage.removeItem('admin_info')
}
